var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c("v-client-table", {
        ref: "commissionDetailsTable",
        staticClass:
          "vue-custom-table no-pagination text-center table-borderless",
        attrs: {
          data: _vm.tableData,
          columns: _vm.tableColumns,
          options: _vm.options,
          name: "consentRequestsTable",
        },
        scopedSlots: _vm._u([
          {
            key: "h__agentSplit",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center" },
                  [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "direct-to-lender.commissions.commissionDetails.agentSplit"
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.showAgentSplitError
                      ? _c("notification-popover", {
                          attrs: { triggers: "hover", type: "error" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "popoverContent",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t(
                                            "direct-to-lender.commissions.commissionDetails.splitsMustAddTo"
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "popoverTarget",
                                fn: function () {
                                  return [
                                    _c("icon", {
                                      staticClass: "text-danger ml-1 clickable",
                                      attrs: { name: "exclamation-circle" },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2692398575
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "agents",
            fn: function (ref) {
              var row = ref.row
              var index = ref.index
              return [
                index === 1
                  ? _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "text-left", attrs: { cols: "4" } },
                          [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v(_vm._s(_vm.$t("global.words.firm"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        index === 2
                          ? _c(
                              "b-col",
                              {
                                staticClass: "text-left",
                                attrs: { cols: "4" },
                              },
                              [
                                _c("span", { staticClass: "bold capitalize" }, [
                                  _vm._v(
                                    _vm._s(_vm.$tc("global.doorr.agent", 1)) +
                                      ":"
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            class: { "offset-4": index > 2, "text-left": true },
                            attrs: { cols: "8" },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.getParticipantName(row))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
              ]
            },
          },
          {
            key: "primaryContact",
            fn: function (ref) {
              var row = ref.row
              var index = ref.index
              return [
                index > 1
                  ? _c("div", { staticClass: "pretty p-icon p-round" }, [
                      _c("input", {
                        staticClass: "form-check-input",
                        attrs: {
                          id: "primary-contact--before",
                          type: "radio",
                          name: "primary-contacts",
                          value: "none",
                          disabled: _vm.isReadOnly,
                        },
                        domProps: { checked: row.primaryContact },
                        on: {
                          change: function ($event) {
                            return _vm.changePrimaryContact(row)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "state p-primary-o" }, [
                        _c("i", { staticClass: "icon fa fa-check" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "hidden-text",
                            attrs: { for: "primary-contact--before" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "direct-to-lender.commissions.commissionDetails.primaryContact"
                                )
                              )
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "firmAgentSplit",
            fn: function (ref) {
              var index = ref.index
              return [
                index === 1
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c(
                          "field",
                          {
                            staticClass: "w-70",
                            attrs: {
                              "container-class": "perc-append",
                              calculated: "",
                              "auto-calculated": false,
                            },
                          },
                          [
                            _c("text-section", {
                              staticClass: "mb-0",
                              attrs: {
                                value: _vm.firmPercentage,
                                name: "commissions-firm-percentage",
                                calculated: "",
                                "auto-calculated": false,
                                disabled: _vm.isReadOnly,
                                placeholder: "0.00",
                                decimals: 2,
                                "max-length": 3,
                                "show-max-length-label": false,
                                "class-name": "decimal-input",
                                label: _vm.$t(
                                  "direct-to-lender.commissions.commissionDetails.firmAgentSplit"
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeFirmPercentage($event, true)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : index === 2
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c(
                          "field",
                          {
                            staticClass: "w-70",
                            attrs: {
                              "container-class": "perc-append",
                              calculated: "",
                              "auto-calculated": false,
                            },
                          },
                          [
                            _c("text-section", {
                              staticClass: "mb-0",
                              attrs: {
                                value: _vm.agentsPercentage,
                                name: "commissions-agents-percentage",
                                calculated: "",
                                "auto-calculated": false,
                                disabled: _vm.isReadOnly,
                                placeholder: "0.00",
                                decimals: 2,
                                "max-length": 3,
                                "show-max-length-label": false,
                                label: _vm.$t(
                                  "direct-to-lender.commissions.commissionDetails.firmAgentSplit"
                                ),
                                "class-name": "decimal-input",
                              },
                              on: { change: _vm.changeAgentsPercentage },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "agentSplit",
            fn: function (ref) {
              var row = ref.row
              var index = ref.index
              return [
                index > 1
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-center agent-split-row",
                      },
                      [
                        _c(
                          "field",
                          {
                            staticClass: "w-70",
                            attrs: {
                              "container-class": "perc-append",
                              calculated: "",
                              "auto-calculated": false,
                            },
                          },
                          [
                            _c("material-input", {
                              staticClass:
                                "mb-0 bordered-input calculated-input",
                              attrs: {
                                "validator-context": _vm.v$,
                                "custom-expression":
                                  "participants.$each[" + (index - 2) + "]",
                                value: _vm.agentsPercentage,
                                "hidden-label": "",
                                "label-for": "agent-split",
                                label: _vm.$t(
                                  "direct-to-lender.commissions.commissionDetails.agentSplit"
                                ),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var inputClasses = ref.inputClasses
                                      return [
                                        _c("percentage-input", {
                                          class:
                                            "calculated-field " + inputClasses,
                                          attrs: {
                                            id: "agent-split",
                                            value: row.agentSplit,
                                            placeholder: "0",
                                            name: "commissions-agent-split-percentage",
                                            disabled: _vm.isReadOnly,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleChangeAgentSplit(
                                                row,
                                                $event.target.value,
                                                index === 2
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "fees",
            fn: function (ref) {
              var row = ref.row
              var index = ref.index
              return [
                index > 1 || row.isFirm
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c(
                          "field",
                          {
                            staticClass: "w-70",
                            attrs: {
                              "side-label": false,
                              "container-class": "dollar-prepend",
                              calculated: "",
                            },
                          },
                          [
                            _c("text-section", {
                              staticClass: "mb-0",
                              attrs: {
                                placeholder: "0.00",
                                "class-name": "calculated dollar",
                                calculated: "",
                                decimals: 2,
                                "allow-minus": "",
                                label: _vm.$t(
                                  "direct-to-lender.commissions.sectionNames.fees"
                                ),
                                value: row.fees,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "netFees",
            fn: function (ref) {
              var row = ref.row
              var index = ref.index
              return [
                index > 1 || row.isFirm
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c(
                          "field",
                          {
                            staticClass: "w-70",
                            attrs: {
                              "side-label": false,
                              "container-class": "dollar-prepend",
                              calculated: "",
                            },
                          },
                          [
                            _c("text-section", {
                              staticClass: "mb-0",
                              attrs: {
                                placeholder: "0.00",
                                "class-name": "calculated dollar",
                                calculated: "",
                                decimals: 2,
                                "allow-minus": "",
                                label: _vm.$t(
                                  "direct-to-lender.commissions.commissionDetails.netFees"
                                ),
                                value: row.netFees,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "actions",
            fn: function (ref) {
              var row = ref.row
              var index = ref.index
              return [
                index > 2 && !_vm.isReadOnly
                  ? _c(
                      "div",
                      [
                        _c("inline-prompt", {
                          staticStyle: { "font-size": "0.8rem" },
                          attrs: { "action-type": "delete" },
                          on: {
                            accept: function ($event) {
                              return _vm.handleRemoveParticipant(row)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }